import PropTypes from 'prop-types';
import {Redirect, Route} from 'react-router-dom';
import {useSelector} from 'react-redux';

const ProtectedRoute = ({page, exact, path}) => {
  const {isError} = useSelector((state) => state.cwa);

  const getContainer = () => {
    if (!isError) {
      return page;
    }

    return <Redirect to="/error" />;
  };

  return <Route exact={exact} path={path} render={() => getContainer()} />;
};

ProtectedRoute.propTypes = {
  path: PropTypes.string.isRequired,
  page: PropTypes.object.isRequired,
  exact: PropTypes.bool,
};

ProtectedRoute.defaultProps = {
  exact: false,
};

export default ProtectedRoute;
